var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87045 5.72764L0.407228 2.26441C-0.0145746 1.84261 -0.108703 1.35998 0.124842 0.816521C0.3575 0.272174 0.773531 0 1.37293 0H8.23278C8.83218 0 9.24821 0.272174 9.48087 0.816521C9.71442 1.35998 9.62029 1.84261 9.19848 2.26441L5.73526 5.72764C5.60206 5.86084 5.45776 5.96074 5.30236 6.02734C5.14696 6.09394 4.98046 6.12724 4.80286 6.12724C4.62526 6.12724 4.45875 6.09394 4.30335 6.02734C4.14795 5.96074 4.00365 5.86084 3.87045 5.72764Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectarrow);
export default __webpack_public_path__ + "static/media/selectarrow.a417f598fead8f84bd8266e0036d547d.svg";
export { ForwardRef as ReactComponent };